import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type MathsStudentSummaryRoute from 'teacher-ui-client/reporting/ui-scope/maths/student-summary/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor('reporting.ui-scope.maths.student-summary') as ModelFor<MathsStudentSummaryRoute>

    const statsScope: StudentsScope = { scope: 'students', ids: [student.id] }

    const product: LegacyProductMs = 'maths'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      period,
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests = async (product: LegacyProductMs, scope: StudentsScope, period: NormalizedInterval) => {
    const { studentEvents } = this
    return RSVP.hash({
      courseProgressStudent: studentEvents.courseProgressLessonsStudent(product, 'lessons', scope, period),
      assessmentScoresStudent: studentEvents.assessmentScoresStudent(product, scope, period),
      awardsEarnedByMonthEvents: studentEvents.awardsEarnedByMonthEvents(product, scope, period),
      drivingTestsStudent: studentEvents.drivingTestsStudentMs(product, scope, period),
    })
  }
}
